import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from '@emotion/styled/macro'
import Button from '../Forms/Button'
import GlobalState from '../../globalState'
import mq from 'mediaQuery'
import useDarkMode from 'use-dark-mode'

const SaveCancelSwitchContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  felx-wrap: wrap;
  align-items: flex-start;
  ${mq.medium`
    flex-direction: row;
  `}
`
const SaveCancelContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-self: flex-end;
  margin-top: 25px;
  ${mq.medium`
    justify-content: flex-end;
  `}
`

const Cancel = styled(Button)`
  // width: 120px;
  padding: 10px 20px;
  margin-right: 5px;

  border-radius: 0;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 160%;
  letter-spacing: 0.15px;
  border: 0.5px solid #e7303c;
  background: ${({ isDark }) => (isDark ? '#E7303C' : '#fff')};
  color: ${({ isDark }) => (isDark ? '#fff' : '#e7303c')};

  &:visited {
    color: inherit;
  }
  &:hover {
    cursor: pointer;
    border: none;
    background: ${({ isDark }) => (isDark ? '#E7303C' : '#fff')};
    box-shadow: none;
    border-radius: 0;
    border: 0.5px solid #e7303c;
  }

  ${mq.medium`
    min-width: 210px;
    padding: 20px 50px
  `}
`

const Save = styled(Cancel)`
  background: #5e17fe;
  color: #fff;
  border: none;
  &:hover {
    background: #5e17fe;
    border: none;
  }
`

const Switch = styled(Button)`
  margin-bottom: 5px;
  ${mq.medium`
    margin-right: 20px;
    margin-bottom: 0px; 
  `}
`

const Warning = styled('div')`
  color: #f5a623;
  align-self: center;
  margin-right: 20px;
`

const ActionButton = ({
  disabled,
  mutation,
  mutationButton,
  value,
  newValue,
  extraDataComponent,
  confirm,
  isValid
}) => {
  const { t } = useTranslation()
  const { toggleModal } = useContext(GlobalState)
  // Ignore isValid == undefined
  if (disabled || isValid === false) {
    return (
      <Save data-testid="action" type="disabled">
        {mutationButton ? mutationButton : t('c.save')}
      </Save>
    )
  }
  if (confirm) {
    return (
      <Save
        data-testid="action"
        onClick={() =>
          toggleModal({
            name: 'confirm',
            mutation: mutation,
            mutationButton: mutationButton,
            value: value,
            newValue: newValue,
            extraDataComponent,
            cancel: () => {
              toggleModal({ name: 'confirm' })
            }
          })
        }
      >
        {mutationButton}
      </Save>
    )
  }
  return (
    <Save data-testid="action" onClick={mutation}>
      {mutationButton ? mutationButton : 'Save'}
    </Save>
  )
}

export const SaveCancel = React.forwardRef(
  (
    {
      mutation,
      mutationButton,
      stopEditing,
      disabled,
      className,
      value,
      newValue,
      confirm,
      warningMessage,
      extraDataComponent,
      isValid = true
    },
    ref
  ) => {
    const { t } = useTranslation()
    const darkMode = useDarkMode()
    const isDark = darkMode.value

    return (
      <SaveCancelContainer className={className} ref={ref}>
        {warningMessage ? <Warning>{warningMessage}</Warning> : null}
        <Cancel
          data-testid="cancel"
          type="hollow"
          isDark={isDark}
          onClick={stopEditing}
        >
          {t(`c.cancel`)}
        </Cancel>
        <ActionButton
          disabled={disabled}
          mutation={mutation}
          mutationButton={mutationButton}
          value={value}
          newValue={newValue}
          confirm={confirm}
          isValid={isValid}
          extraDataComponent={extraDataComponent}
          data-testid="action"
        />
      </SaveCancelContainer>
    )
  }
)

export const SaveCancelSwitch = ({
  mutation,
  mutationButton,
  startUploading,
  stopUploading,
  stopAuthorizing,
  disabled,
  className,
  value,
  newValue,
  confirm,
  warningMessage,
  isValid = true
}) => (
  <SaveCancelSwitchContainer className={className}>
    {warningMessage ? <Warning>{warningMessage}</Warning> : null}
    {newValue !== '' && (
      <Switch data-testid="reset" type="hollow" onClick={startUploading}>
        New Upload
      </Switch>
    )}
    <Switch data-testid="switch" type="hollow" onClick={stopAuthorizing}>
      Logout
    </Switch>
    <Switch data-testid="cancel" type="hollow" onClick={stopUploading}>
      Cancel
    </Switch>
    <ActionButton
      disabled={disabled}
      mutation={mutation}
      mutationButton={mutationButton}
      value={value}
      newValue={newValue}
      confirm={confirm}
      isValid={isValid}
      data-testid="action"
    />
  </SaveCancelSwitchContainer>
)

export default SaveCancel
